import React, { useEffect, useState } from "react";
import Billingdetailsform from "../../Forms/Billingdetailsform/Billingdetailsform";

export default function Billingdetails() {

    const [billingsubmit, setBillingsubmit] = useState(true)

    useEffect(() => {

        window.scrollTo(0, 0)

    }, [])

    return (
        <>

            {/* Billingdetails start */}

            {billingsubmit ? <div className="billing_details">
                <div className="d-flex justify-content-between createaccountpage_content_header_container">
                    <div className="d-flex">
                        <div>
                            <div className="d-flex">
                                <div className="createaccountpage_content_header">
                                    Billing Details
                                </div>
                                <div>
                                    <button type="button" className="createaccountpage_edit_button" onClick={() => setBillingsubmit(false)}>
                                        Edit
                                    </button>
                                </div>
                            </div>
                            <div className="createaccountpage_content_text">
                                Your billing and payment details
                            </div>
                        </div>
                        <div>
                        </div>
                    </div>
                </div>

                <div className="createaccountpage_margin_bottom">

                    <button className="createaccountpage_content_button" data-bs-toggle="collapse" data-bs-target="#billto" aria-expanded="true" aria-controls="billto">
                        Bill to
                    </button>
                    <div id="billto" className="collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">

                        <table className="createaccountpage_content_table">
                            <tbody>
                                <tr>
                                    <td>Business Name</td>
                                    <td>The Good Bookstore</td>
                                </tr>
                                <tr>
                                    <td>Address 1</td>
                                    <td>371 Alexandra Road #06-19 AIA Building</td>
                                </tr>
                                <tr>
                                    <td>Address 2</td>
                                    <td>3 Sungei Kadut Crescent</td>
                                </tr>
                                <tr>
                                    <td>City</td>
                                    <td>Singapore</td>
                                    <td>State</td>
                                    <td>Singapore</td>
                                    <td>Country</td>
                                    <td>Singapore</td>
                                </tr>
                                <tr>
                                    <td>Postal Code</td>
                                    <td>728686</td>
                                </tr>
                                <tr>
                                    <td>Phone</td>
                                    <td>63620721</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                </div>

                <div className="createaccountpage_margin_bottom">

                    <button className="createaccountpage_content_button" data-bs-toggle="collapse" data-bs-target="#contactdetails" aria-expanded="true" aria-controls="contactdetails">
                        Contact Details
                    </button>
                    <div id="contactdetails" className="collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">

                        <table className="createaccountpage_content_table">

                            <tbody>
                                <tr>
                                    <td>Contact Person</td>
                                    <td>David Brown</td>
                                </tr>
                                <tr>
                                    <td>Email Address</td>
                                    <td>d.brown@gmail.com</td>
                                </tr>
                                <tr>
                                    <td>Contact Number</td>
                                    <td>84578294</td>
                                </tr>

                                <tr>
                                    <td>Finance Contact Person</td>
                                    <td>Frederick Thomas</td>

                                </tr>

                                <tr>
                                    <td>State</td>
                                    <td>Singapore</td>
                                    <td>Postal Code</td>
                                    <td>728686</td>
                                </tr>
                                <tr>
                                    <td>Email Address</td>
                                    <td>f.thomas@gmail.com</td>
                                </tr>
                                <tr>
                                    <td>Contact Number</td>
                                    <td>63620721</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="createaccountpage_margin_bottom">

                    <button className="createaccountpage_content_button" data-bs-toggle="collapse" data-bs-target="#bankinformation" aria-expanded="true" aria-controls="bankinformation">
                        Bank Information
                    </button>
                    <div id="bankinformation" className="collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">

                        <table className="createaccountpage_content_table">

                            <tbody>
                                <tr>
                                    <td>Bank Name</td>
                                    <td>DBS Bank Ltd</td>
                                </tr>
                                <tr>
                                    <td>Bank Account Number</td>
                                    <td>8453839102</td>
                                </tr>
                                <tr>
                                    <td>Address 1</td>
                                    <td>12 Marina Boulevard, DBS Asia Central</td>
                                </tr>

                                <tr>
                                    <td>Address 2</td>
                                    <td>Marina Bay Financial Centre Tower 3, Singapore 018982</td>

                                </tr>

                                <tr>
                                    <td>City</td>
                                    <td>Singapore</td>
                                    <td>State</td>
                                    <td>Singapore</td>
                                    <td>Country</td>
                                    <td>Singapore</td>
                                </tr>
                                <tr>
                                    <td>Postal Code</td>
                                    <td>728686</td>
                                </tr>
                                <tr>
                                    <td>Contact Person</td>
                                    <td>Rose Valeri</td>
                                </tr>
                                <tr>
                                    <td>Email</td>
                                    <td>valeri@dbsbank.sg</td>
                                </tr>
                                <tr>
                                    <td>Phone</td>
                                    <td>74839302</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div> : <Billingdetailsform />}


            {/* Billingdetails over */}

        </>
    )

}